import Modal from './Modal';

interface CGUModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function CGUModal({ isOpen, onClose }: CGUModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Conditions Générales d'Utilisation"
      showFooterClose
    >
      <div className="p-6 space-y-6 text-gray-700 dark:text-warm-gray-300">
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">Article 1 – Objet</h3>
          <p>
            Les présentes Conditions Générales d'Utilisation ont pour objet de définir les
            modalités et conditions d'accès et d'utilisation du site{' '}
            <a
              href="https://aurorerh.fr"
              className="text-aurore-dark hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              aurorerh.fr
            </a>{' '}
            (ci-après « le Site »).
          </p>
          <p className="mt-2">
            Toute navigation sur le Site implique l'acceptation pleine et entière des présentes
            CGU par l'utilisateur.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">Article 2 – Accès au site</h3>
          <p>
            Le Site est accessible gratuitement à tout utilisateur disposant d'un accès à
            Internet. Les frais liés à l'accès (connexion Internet, matériel, logiciels, etc.)
            sont à la charge exclusive de l'utilisateur.
          </p>
          <p className="mt-2">
            Aurore RH se réserve le droit de suspendre, restreindre ou interrompre l'accès au
            Site, sans préavis, notamment pour des raisons de maintenance ou de mise à jour.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">
            Article 3 – Services proposés
          </h3>
          <p className="mb-3">
            Le Site a pour vocation de présenter les activités et prestations proposées par Aurore
            RH, notamment dans les domaines suivants :
          </p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>conseil et accompagnement RH</li>
            <li>audit social et conformité</li>
            <li>recrutement et gestion des talents</li>
            <li>formation professionnelle</li>
            <li>accompagnement des employeurs et des salariés</li>
          </ul>
          <p className="mt-3">
            Les informations diffusées sur le Site sont fournies à titre informatif et ne
            constituent en aucun cas un engagement contractuel.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">Article 4 – Responsabilité</h3>
          <p>
            Aurore RH met tout en œuvre pour fournir des informations fiables et à jour.
            Toutefois, elle ne saurait garantir l'exactitude, la complétude ou l'actualité
            permanente des contenus diffusés.
          </p>
          <p className="mt-2">
            L'utilisateur reconnaît utiliser le Site sous sa seule responsabilité. Aurore RH ne
            pourra être tenue responsable de dommages directs ou indirects résultant de
            l'utilisation du Site, de l'impossibilité d'y accéder ou de l'utilisation des
            informations qui y sont présentées.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">
            Article 5 – Propriété intellectuelle
          </h3>
          <p>
            L'ensemble du Site, ainsi que son contenu (textes, images, graphismes, logos,
            documents, structure, charte graphique), est protégé par le droit de la propriété
            intellectuelle.
          </p>
          <p className="mt-2">
            Toute reproduction, représentation, diffusion ou exploitation, totale ou partielle,
            sans autorisation écrite préalable d'Aurore RH est strictement interdite et
            susceptible de poursuites.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">
            Article 6 – Données personnelles
          </h3>
          <p>
            Le Site ne stocke aucune donnée personnelle directement sur le domaine aurorerh.fr.
          </p>
          <p className="mt-2">
            Lorsque l'utilisateur utilise un formulaire/sondage, les informations saisies sont
            enregistrées et traitées via Tally. Lorsque l'utilisateur prend un rendez-vous, les
            informations nécessaires à la prise de rendez-vous sont enregistrées et traitées via
            Cal.eu, Ces services tiers déclarent être conformes au RGPD.
          </p>
          <p className="mt-2">
            Ces données sont traitées conformément à la réglementation en vigueur (RGPD et loi
            Informatique et Libertés). Pour plus d'informations, l'utilisateur est invité à
            consulter la Politique de confidentialité du Site.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">Article 7 – Cookies</h3>
          <p>
            Le Site utilise des cookies afin d'améliorer l'expérience utilisateur et d'analyser la
            fréquentation. L'utilisateur peut à tout moment configurer son navigateur pour
            accepter, refuser ou limiter les cookies.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">Article 8 – Liens externes</h3>
          <p>
            Le Site peut contenir des liens vers des sites tiers. Aurore RH n'exerce aucun
            contrôle sur ces sites et ne saurait être tenue responsable de leur contenu, de leur
            politique de confidentialité ou de leur fonctionnement.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">
            Article 9 – Modification des CGU
          </h3>
          <p>
            Aurore RH se réserve le droit de modifier les présentes CGU à tout moment. Les CGU
            applicables sont celles en vigueur à la date de la consultation du Site.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">
            Article 10 – Droit applicable et juridiction compétente
          </h3>
          <p>Les présentes CGU sont soumises au droit français.</p>
          <p className="mt-2">
            En cas de litige et à défaut de résolution amiable, les tribunaux français seront
            seuls compétents.
          </p>
        </section>
      </div>
    </Modal>
  );
}
